import React from "react";
import { useDrag } from "react-dnd";
import { ItemSubtypes, ItemTypes } from "../../../DnDTypes";
import styles from "./index.module.css";

// GROUP component - renders only as a label/header, no input field
// Used as a visual separator/section header in forms

const GroupControl = ({
  id,
  isSelected = false,
  dragMode = "move",
  configuration = {},
  markSelected,
  showSelfDescription,
  sidebarMode,
  formCreatorMode,
  displayMode,
}) => {
  const [, drag] = useDrag({
    item: { type: ItemTypes.COMPONENT, subtype: ItemSubtypes.GROUP, dragMode },
    collect: (monitor) => {
      return {
        isDragging: !!monitor.isDragging(),
      };
    },
    canDrag: () => {
      return dragMode === "move" || dragMode === "clone";
    },
  });

  const clicked = () =>
    markSelected &&
    markSelected({
      id,
      dataType: ItemSubtypes.GROUP,
      configuration,
    });

  // Sidebar mode - show simplified version
  if (sidebarMode) {
    return (
      <div ref={drag} className={styles.sidebarGroup}>
        <strong>Grupa</strong>
      </div>
    );
  }

  // Form creator mode - show with configuration
  if (formCreatorMode) {
    return (
      <div
        ref={drag}
        className={`${styles.groupHeader} ${isSelected ? styles.selected : ""}`}
        onClick={clicked}
      >
        <strong>{configuration.label || "Grupa"}</strong>
      </div>
    );
  }

  // Display mode - render as a bold header/label only (no input)
  const labelText = showSelfDescription
    ? "Grupa"
    : configuration.label || "Grupa";

  const labelStyle = {
    fontWeight: configuration.bold ? "bold" : "normal",
    fontStyle: configuration.italic ? "italic" : "normal",
    fontSize: configuration.fontSize ? `${configuration.fontSize}px` : "20px",
    display: "block",
    marginTop: "20px",
    marginBottom: "10px",
  };

  return (
    <div ref={drag} onClick={clicked}>
      <div style={labelStyle}>{labelText}</div>
    </div>
  );
};

export default GroupControl;
